import { supabase } from '../lib/supabase';

/**
 * Profile Service - Maneja las operaciones de perfil del usuario
 */

export const profileService = {
  /**
   * Obtener estadísticas del perfil del usuario
   * @param {string} userId - ID del usuario
   */
  async getProfileStats(userId) {
    // Obtener perfil
    const { data: profile, error: profileError } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();

    if (profileError) {
      console.error('Error fetching profile:', profileError);
      return null;
    }

    // Contar recetas subidas
    const { count: recipesCount } = await supabase
      .from('recipes')
      .select('*', { count: 'exact', head: true })
      .eq('author_id', userId);

    return {
      ...profile,
      recipes_uploaded: recipesCount || 0,
      recipes_completed: profile.recipes_completed || 0,
      followers_count: profile.followers_count || 0,
      following_count: profile.following_count || 0
    };
  },

  /**
   * Incrementar contador de recetas completadas
   * @param {string} userId - ID del usuario
   */
  async incrementRecipesCompleted(userId) {
    const { data, error } = await supabase.rpc('increment_recipes_completed', {
      user_id: userId
    });

    // Si la función RPC no existe, hacerlo manualmente
    if (error) {
      const { data: profile } = await supabase
        .from('profiles')
        .select('recipes_completed')
        .eq('id', userId)
        .single();

      const currentCount = profile?.recipes_completed || 0;
      
      await supabase
        .from('profiles')
        .update({ recipes_completed: currentCount + 1 })
        .eq('id', userId);
    }

    return true;
  },

  /**
   * Obtener lista de seguidores
   * @param {string} userId - ID del usuario
   */
  async getFollowers(userId) {
    const { data, error } = await supabase
      .from('follows')
      .select(`
        created_at,
        follower:follower_id (
          id,
          display_name,
          username,
          avatar_url,
          bio,
          followers_count
        )
      `)
      .eq('following_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching followers:', error);
      return [];
    }

    return data?.map(f => ({
      ...f.follower,
      followed_at: f.created_at
    })).filter(Boolean) || [];
  },

  /**
   * Obtener lista de usuarios que sigue
   * @param {string} userId - ID del usuario
   */
  async getFollowing(userId) {
    const { data, error } = await supabase
      .from('follows')
      .select(`
        created_at,
        following:following_id (
          id,
          display_name,
          username,
          avatar_url,
          bio,
          followers_count
        )
      `)
      .eq('follower_id', userId)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching following:', error);
      return [];
    }

    return data?.map(f => ({
      ...f.following,
      followed_at: f.created_at
    })).filter(Boolean) || [];
  }
};

export default profileService;
